import { ErrorMessage, Field, useFormikContext } from 'formik';

const PUBLIC_EMAIL_DOMAINS = new Set([
  '126.com', '139.com', '163.com', 'alice.it', 'aol.com', 'asia.com', 'att.net',
  'bell.net', 'bellsouth.net', 'bigpond.com', 'bigpond.net.au', 'bk.ru', 'bluewin.ch',
  'blueyonder.co.uk', 'bol.com.br', 'btinternet.com', 'charter.net', 'comcast.net',
  'cox.net', 'daum.net', 'earthlink.net', 'email.com', 'email.cz', 'europe.com',
  'fastmail.com', 'fastmail.fm', 'foxmail.com', 'free.fr', 'freenet.de', 'globo.com',
  'gmail.com', 'gmx.co.uk', 'gmx.com', 'gmx.de', 'gmx.net', 'googlemail.com',
  'hanmail.net', 'hispeed.ch', 'hotmail.com', 'icloud.com', 'ig.com.br',
  'iinet.net.au', 'iname.com', 'inbox.ru', 'interia.pl', 'kpnmail.nl', 'laposte.net',
  'libero.it', 'list.ru', 'live.com', 'mac.com', 'mail.com', 'mail.de', 'mail.ru',
  'me.com', 'msn.com', 'naver.com', 'ntlworld.com', 'o2.pl', 'onet.pl',
  'optusnet.com.au', 'orange.fr', 'outlook.com', 'planet.nl', 'pm.me', 'post.com',
  'post.cz', 'posteo.de', 'proton.me', 'protonmail.ch', 'protonmail.com', 'qq.com',
  'rambler.ru', 'rediffmail.com', 'rocketmail.com', 'rogers.com', 'sbcglobal.net',
  'seznam.cz', 'sfr.fr', 'sina.com', 'skynet.be', 'sky.com', 'sohu.com', 'sunrise.ch',
  'sympatico.ca', 'talktalk.net', 'telenet.be', 'terra.com.br', 'tiscali.it',
  't-online.de', 'tuta.com', 'tutanota.com', 'ukr.net', 'uol.com.br', 'usa.com',
  'verizon.net', 'virginmedia.com', 'virgilio.it', 'wanadoo.fr', 'web.de', 'wp.pl',
  'xs4all.nl', 'ya.ru', 'yahoo.ca', 'yahoo.co.in', 'yahoo.co.jp', 'yahoo.co.uk',
  'yahoo.com', 'yahoo.com.ar', 'yahoo.com.br', 'yahoo.de', 'yahoo.es', 'yahoo.fr',
  'yandex.com', 'yandex.ru', 'yeah.net', 'ymail.com', 'ziggo.nl', 'zoho.com',
  'zohomail.com',
]);

const isLikelyWorkEmail = (email) => {
  if (!email || typeof email !== 'string') return false;
  const at = email.lastIndexOf('@');
  if (at < 1 || at === email.length - 1) return false;
  const domain = email.slice(at + 1).trim().toLowerCase();
  if (!domain.includes('.')) return false;
  return !PUBLIC_EMAIL_DOMAINS.has(domain);
};

export const StepOne = () => {
  const { values } = useFormikContext();
  const showWorkEmailHint = isLikelyWorkEmail(values?.email);

   const preventDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const preventDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "none";
  };
  return (
    <div className="main-container step">
      {/* <h6 className="text-lg font-medium leading-6 text-gray-900">Basic Information</h6> */}
      <div className=" form-control2">
        <label htmlFor="name" className="text-sm font-medium text-gray-700">
          Name <span>*</span>
        </label>
        <Field
          name="name"
          type="text"
          placeholder="Enter your name"
          className="mt-1   w-full border border-gray-300 rounded-md shadow-sm p-2"
          onDragOver={preventDrag} onDrop={preventDrop}
        />
        <ErrorMessage name="name" component="div" className="text-red-500 text-sm" />
      </div>
      <div className=" form-control2">
        <label htmlFor="email" className="block text-sm font-medium text-gray-700">
          Email <span>*</span>
        </label>
        <Field
          name="email"
          type="email"
          placeholder="Enter your email"
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
          onDragOver={preventDrag} onDrop={preventDrop}
        />
        <ErrorMessage name="email" component="div" className="text-red-500 text-sm" />
        {showWorkEmailHint && (
          <div className="mt-1 text-sm text-amber-700">
            For your privacy, we recommend using a personal email, as work emails may be accessible by your employer.
          </div>
        )}
      </div>
      <div className="form-control2">
        <label htmlFor="name" className="text-sm font-medium text-gray-700">
          Phone number
        </label>
        <Field
          name="phone"
          type="phone"
          pattern="[0-9]*"
          inputMode="numeric"
          className="mt-1 w-full border border-gray-300 rounded-md shadow-sm p-2"
          onDragOver={preventDrag} onDrop={preventDrop}
        />
        <ErrorMessage name="phone" component="div" className="text-red-500 text-sm" />
      </div>
    </div>
  );
};